import React, { useState, useEffect } from 'react'; 
import {
  get_beneficiary_info,
  get_all_countries

} from '../../services/common';

const Beneficiary = ({ beneficiaryId, show, onClose }) => {
    const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL;
  const [bform, setBform] = useState({});
  const [countries, setCountries] = useState([]);
  const [loadOn, setLoadOn] = useState(false);
  
  useEffect(() => {
    if (show && beneficiaryId) {
      fetchBeneficiaryInfo();
      fetchCountries();
    }
  }, [show, beneficiaryId]);

  useEffect(()=>{
    console.log("updated form", bform)
  },[bform])
  const fetchBeneficiaryInfo = async () => {
    setLoadOn(true);
    try {
        const userToken = localStorage.getItem('systemToken');
        const response = await get_beneficiary_info(userToken, beneficiaryId);
        console.log("dahwdjaj",response)
      if (response) {
        console.log(response.beneficiary);
        setBform(response.beneficiary);
        const documents = JSON.parse(response.beneficiary.beneficiary_documents);
        setBform(prev => ({
          ...prev,
          is_colour_passport: documents.is_colour_passport.toString(),
          is_residence_proof: documents.is_residence_proof.toString(),
          is_contract_proof: documents.is_contract_proof.toString(),
          is_incorporation_certi: documents.is_incorporation_certi.toString(),
          is_driver_license: documents.is_driver_license.toString(),
        }));
      } else {
         
      }
    } catch (error) {
     
    } finally {
      setLoadOn(false);
    }
  };

  
  const fetchCountries = async () => {
    try {
      const userToken = localStorage.getItem('systemToken');
        
      const response = await get_all_countries(userToken);
      if (response?.success === 1) {
        console.log("user con")
        setCountries(response.data.countries || []);
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };
  const updateBeneficiary = async (e) => {
    e.preventDefault();
    setLoadOn(true);
    try {
      const userToken = localStorage.getItem('systemToken');
      const formData = new FormData();
      Object.keys(bform).forEach(key => {
        formData.append(key, bform[key]);
      });

      formData.append('user_token', userToken);

      const response = await fetch(`${BASE_URL}/save-beneficiary`, {
        method: 'POST',
        body: formData,
    
      });
      if (response.data.success === 200) {
        
        onClose();
      } else {  
      }
    } catch (error) {
      
    } finally {
      setLoadOn(false);
    }
  };

  return (
    <div className={`fixed inset-0 z-50 ${show ? 'flex' : 'hidden'} items-center justify-center bg-black bg-opacity-50`}>
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl mx-4 overflow-y-auto max-h-screen">
        <div className="flex justify-between items-center p-4 border-b">
          <h5 className="text-lg font-bold">Beneficiary Details</h5>
          <button type="button" className="text-gray-500 hover:text-gray-700" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="p-4">
          {loadOn ? (
            <div className="text-center">Loading...</div>
          ) : (
            <form onSubmit={updateBeneficiary} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="form-group">
                  <label className="block text-sm font-medium text-gray-700">Corporate or Individual</label>
                  <select
                    value={bform.beneficiary_type || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_type: e.target.value })}
                    className= "form-control mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm p-2"
                  >
                    <option value="">Select type</option>
                    <option value="corporate">Corporate</option>
                    <option value="individual">Individual</option>
                  </select>
                </div>
                {bform.beneficiary_type === 'corporate' && (
                  <>
                    <div className="form-group">
                      <label>Name of beneficiary</label>
                      <input
                        type="text"
                        value={bform.beneficiary_name || ''}
                        onChange={(e) => setBform({ ...bform, beneficiary_name: e.target.value })}
                        className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div className="form-group">
                      <label>Company registration number of beneficiary</label>
                      <input
                        type="text"
                        value={bform.beneficiary_company_reg_no || ''}
                        onChange={(e) => setBform({ ...bform, beneficiary_company_reg_no: e.target.value })}
                        className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div className="form-group">
                      <label>Country of residency of Beneficiary</label>
                      <select
                        value={bform.beneficiary_nationality || ''}
                        onChange={(e) => setBform({ ...bform, beneficiary_nationality: e.target.value })}
                        className="form-control"
                      >
                        <option value="">Select Country</option>
                        {countries.map(country => (
                          <option key={country.country_id} value={country.country_id}>
                            {country.country_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Country of registration of Beneficiary</label>
                      <select
                        value={bform.beneficiary_reg_country || ''}
                        onChange={(e) => setBform({ ...bform, beneficiary_reg_country: e.target.value })}
                        className="form-control"
                      >
                        <option value="">Select your country</option>
                        {countries.map(country => (
                          <option key={country.country_id} value={country.country_id}>
                            {country.country_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </>
                )}
                {bform.beneficiary_type === 'individual' && (
                  <div className="form-group">
                    <label>Name of person making payment</label>
                    <input
                      type="text"
                      value={bform.beneficiary_name || ''}
                      onChange={(e) => setBform({ ...bform, beneficiary_name: e.target.value })}
                      className="form-control border border-gray-400 bg-gray-50 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Passport number of beneficiary</label>
                  <input
                    type="text"
                    value={bform.beneficiary_passport_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_passport_no: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Passport expiry of beneficiary</label>
                  <input
                    type="date"
                    value={bform.beneficiary_passport_expiry || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_passport_expiry: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Country of issue of passport of beneficiary</label>
                  <select
                    value={bform.beneficiary_passport_country || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_passport_country: e.target.value })}
                    className="form-control"
                  >
                    <option value="">Select your country</option>
                    {countries.map(country => (
                      <option key={country.country_id} value={country.country_id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Date of Birth of Beneficiary</label>
                  <input
                    type="date"
                    value={bform.beneficiary_dob || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_dob: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Home address of Beneficiary</label>
                  <input
                    type="text"
                    value={bform.beneficiary_home_address || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_home_address: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Email address of Beneficiary</label>
                  <input
                    type="email"
                    value={bform.beneficiary_email_id || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_email_id: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Mobile/Cell Number of Beneficiary</label>
                  <input
                    type="text"
                    value={bform.beneficiary_phone_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_phone_no: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Name of bank</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_name || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_name: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Address of bank</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_address || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_address: e.target.value })}
                    className="form-control border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="form-group">
                  <label>Bank SWIFT code</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_swift_code || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_swift_code: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Bank account name</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_ac_name || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_ac_name: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Bank account number</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_ac_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_ac_no: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Beneficiary reference number</label>
                  <input
                    type="text"
                    value={bform.beneficiary_ref_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_ref_no: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Your reference number</label>
                  <input
                    type="text"
                    value={bform.beneficiary_your_ref_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_your_ref_no: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Transmission Type</label>
                  <select
                    value={bform.beneficiary_payment_transmission_type || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_payment_transmission_type: e.target.value })}
                    className="form-control"
                  >
                    <option value="">Select type</option>
                    <option value="swift_mt103">SWIFT MT103</option>
                    <option value="rtgs">RTGS</option>
                    <option value="swift_gpi">SWIFT GPI</option>
                    <option value="bank_draft">Bank Draft</option>
                    <option value="sblc_bg">SBLC/BG</option>
                    <option value="dlc">DLC</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Bank officer name</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_officer_name || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_officer_name: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Bank officer phone number</label>
                  <input
                    type="text"
                    value={bform.beneficiary_bank_officer_phone_no || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_officer_phone_no: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Bank officer email address</label>
                  <input
                    type="email"
                    value={bform.beneficiary_bank_officer_email_address || ''}
                    onChange={(e) => setBform({ ...bform, beneficiary_bank_officer_email_address: e.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Is the Beneficiary a trust?</label>
                  <div>
                    <input
                      type="radio"
                      id="beneficiary_trust0"
                      value="1"
                      checked={bform.beneficiary_trust === '1'}
                      onChange={(e) => setBform({ ...bform, beneficiary_trust: e.target.value })}
                    />
                    <label htmlFor="beneficiary_trust0">Yes</label>
                    <input
                      type="radio"
                      id="beneficiary_trust1"
                      value="0"
                      checked={bform.beneficiary_trust === '0'}
                      onChange={(e) => setBform({ ...bform, beneficiary_trust: e.target.value })}
                    />
                    <label htmlFor="beneficiary_trust1">No</label>
                  </div>
                </div>
                {bform.beneficiary_trust === '1' && (
                  <div className="form-group">
                    <label>Upload trust deed</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, trust_deed: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Is the Beneficiary a USA citizen?</label>
                  <div>
                    <input
                      type="radio"
                      id="usa_citizen0"
                      value="1"
                      checked={bform.beneficiary_usa_citizen === '1'}
                      onChange={(e) => setBform({ ...bform, beneficiary_usa_citizen: e.target.value })}
                    />
                    <label htmlFor="usa_citizen0">Yes</label>
                    <input
                      type="radio"
                      id="usa_citizen1"
                      value="0"
                      checked={bform.beneficiary_usa_citizen === '0'}
                      onChange={(e) => setBform({ ...bform, beneficiary_usa_citizen: e.target.value })}
                    />
                    <label htmlFor="usa_citizen1">No</label>
                  </div>
                </div>
                {bform.beneficiary_type === 'new' && (bform.beneficiary_usa_citizen === '1' || bform.beneficiary_tax_resident_usa === '1') && (
                  <div className="form-group">
                    <label>Social security number of Beneficiary</label>
                    <input
                      type="text"
                      value={bform.beneficiary_social_security_no || ''}
                      onChange={(e) => setBform({ ...bform, beneficiary_social_security_no: e.target.value })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Is the Beneficiary a tax resident of the USA?</label>
                  <div>
                    <input
                      type="radio"
                      id="beneficiary_tax_resident_usa0"
                      value="1"
                      checked={bform.beneficiary_tax_resident_usa === '1'}
                      onChange={(e) => setBform({ ...bform, beneficiary_tax_resident_usa: e.target.value })}
                    />
                    <label htmlFor="beneficiary_tax_resident_usa0">Yes</label>
                    <input
                      type="radio"
                      id="beneficiary_tax_resident_usa1"
                      value="0"
                      checked={bform.beneficiary_tax_resident_usa === '0'}
                      onChange={(e) => setBform({ ...bform, beneficiary_tax_resident_usa: e.target.value })}
                    />
                    <label htmlFor="beneficiary_tax_resident_usa1">No</label>
                  </div>
                </div>
                {bform.beneficiary_type === 'new' && bform.beneficiary_tax_resident_usa === '1' && (
                  <div className="form-group">
                    <label>Beneficiary Tax ID</label>
                    <input
                      type="text"
                      value={bform.beneficiary_tax_id || ''}
                      onChange={(e) => setBform({ ...bform, beneficiary_tax_id: e.target.value })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Certified Copy Colour Passport of Beneficiary (Included)?</label>
                  <div>
                    <input
                      type="radio"
                      id="colorPass0"
                      value="1"
                      checked={bform.is_colour_passport === '1'}
                      onChange={(e) => setBform({ ...bform, is_colour_passport: e.target.value })}
                    />
                    <label htmlFor="colorPass0">Yes</label>
                    <input
                      type="radio"
                      id="colorPass1"
                      value="0"
                      checked={bform.is_colour_passport === '0'}
                      onChange={(e) => setBform({ ...bform, is_colour_passport: e.target.value })}
                    />
                    <label htmlFor="colorPass1">No</label>
                  </div>
                </div>
                {bform.is_colour_passport === '1' && (
                  <div className="form-group">
                    <label>Upload Colour Passport</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, colour_passport: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Certified Copy Utility Bill Showing Proof of Residential Address of Beneficiary (Included?)</label>
                  <div>
                    <input
                      type="radio"
                      id="resiProof0"
                      value="1"
                      checked={bform.is_residence_proof === '1'}
                      onChange={(e) => setBform({ ...bform, is_residence_proof: e.target.value })}
                    />
                    <label htmlFor="resiProof0">Yes</label>
                    <input
                      type="radio"
                      id="resiProof1"
                      value="0"
                      checked={bform.is_residence_proof === '0'}
                      onChange={(e) => setBform({ ...bform, is_residence_proof: e.target.value })}
                    />
                    <label htmlFor="resiProof1">No</label>
                  </div>
                </div>
                {bform.is_residence_proof === '1' && (
                  <div className="form-group">
                    <label>Upload Residence Proof</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, residence_proof: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Copy of contract or invoice between Caprock Account Holder and Beneficiary as proof of transaction (Included)?</label>
                  <div>
                    <input
                      type="radio"
                      id="contract_proof0"
                      value="1"
                      checked={bform.is_contract_proof === '1'}
                      onChange={(e) => setBform({ ...bform, is_contract_proof: e.target.value })}
                    />
                    <label htmlFor="contract_proof0">Yes</label>
                    <input
                      type="radio"
                      id="contract_proof1"
                      value="0"
                      checked={bform.is_contract_proof === '0'}
                      onChange={(e) => setBform({ ...bform, is_contract_proof: e.target.value })}
                    />
                    <label htmlFor="contract_proof1">No</label>
                  </div>
                </div>
                {bform.is_contract_proof === '1' && (
                  <div className="form-group">
                    <label>Upload Contract Proof</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, contract_proof: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
                {bform.beneficiary_type === 'corporate' && (
                  <div className="form-group">
                    <label>Certified Certificate of Incorporation from Beneficiary (Included)?</label>
                    <div>
                      <input
                        type="radio"
                        id="incorporation_certi0"
                        value="1"
                        checked={bform.is_incorporation_certi === '1'}
                        onChange={(e) => setBform({ ...bform, is_incorporation_certi: e.target.value })}
                      />
                      <label htmlFor="incorporation_certi0">Yes</label>
                      <input
                        type="radio"
                        id="incorporation_certi1"
                        value="0"
                        checked={bform.is_incorporation_certi === '0'}
                        onChange={(e) => setBform({ ...bform, is_incorporation_certi: e.target.value })}
                      />
                      <label htmlFor="incorporation_certi1">No</label>
                    </div>
                  </div>
                )}
                {bform.is_incorporation_certi === '1' && (
                  <div className="form-group">
                    <label>Upload Incorporation Certificate</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, incorporation_certi: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Certified Copy of Drivers License of Beneficiary (Included)?</label>
                  <div>
                    <input
                      type="radio"
                      id="driver_license0"
                      value="1"
                      checked={bform.is_driver_license === '1'}
                      onChange={(e) => setBform({ ...bform, is_driver_license: e.target.value })}
                    />
                    <label htmlFor="driver_license0">Yes</label>
                    <input
                      type="radio"
                      id="driver_license1"
                      value="0"
                      checked={bform.is_driver_license === '0'}
                      onChange={(e) => setBform({ ...bform, is_driver_license: e.target.value })}
                    />
                    <label htmlFor="driver_license1">No</label>
                  </div>
                </div>
                {bform.is_driver_license === '1' && (
                  <div className="form-group">
                    <label>Upload Driver License</label>
                    <input
                      type="file"
                      onChange={(e) => setBform({ ...bform, driver_license: e.target.files[0] })}
                      className="form-control"
                    />
                  </div>
                )}
              </div>
              <button type="submit" className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                Update
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Beneficiary;